// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__kz6Q5","loader__spinner":"style_loader__spinner__riylG","fadein":"style_fadein__3XLoS"};